import { connect } from 'react-redux';

import LearningAdminModuleSerieAddScreen from '../components/LearningAdminModuleSerieAddScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSerieAddScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSerieAddScreen);

export default LearningAdminModuleSerieAddScreenContainer;
